<div [formGroup]="formRegister" class="others-developers">

  <div class="others-developers__header">
    <h4 class="others-developers__title">Outros desenvolvedores</h4>
    <div class="others-developers__header-action">
      <b3-button
        class="others-developers__add-btn"
        type="button"
        variant="outlined"
        tone="default"
        [disabled]="validateDisabledButton()"
        (b3-click)="addDevelopers()">
        <b3-icon name="add" size="sm"></b3-icon>
        Incluir novo
      </b3-button>
    </div>
  </div>

  <div class="fields-row fields-row--2">
    <div class="field-group field-group--labeled">
      <b3-input-text
        formControlName="developerCompanyNameAdd"
        inputId="developerCompanyName__AddOthers"
        label="Razão Social"
        background="white"
        mask="text"
        placeholder="Nome da empresa"
        [maxlength]="100">
      </b3-input-text>
    </div>

    <div class="field-group field-group--labeled">
      <b3-input-text
        formControlName="developerCnpjAdd"
        inputId="developerCnpj__AddOthers"
        label="CPF/CNPJ"
        background="white"
        [mask]="developerDocumentMask"
        placeholder="00.000.000/0000-00"
        [maxlength]="18"
        [error]="checkHasErrorDigitCounter('developerCnpjAdd')"
        [hint]="[
          { show: checkHasErrorDigitCounter('developerCnpjAdd'), text: 'O CPF/CNPJ deve conter 11 ou 14 dígitos.' }
        ] | fieldHint"
        (b3-blur)="onChangesInputCpfOrCnpj()">
      </b3-input-text>
    </div>
  </div>

  <h4 class="linked-developers__title">Desenvolvedores vinculados</h4>

  <div class="developers-table" *ngIf="developersAdded.length > 0">
    <div class="developers-table__grid">
      <div class="developers-table__head">
        <span>Razão Social</span>
        <span>CPF/CNPJ</span>
        <span class="developers-table__cell--actions">Ações</span>
      </div>

      <div
        class="developers-table__row"
        *ngFor="let developer of paginatedDevelopers; trackBy: trackByDeveloper">
        <span class="developers-table__name">{{ developer.developerName }}</span>
        <span class="developers-table__document">{{ formatDeveloperDocument(developer.cpfCnpj) }}</span>
        <div class="developers-table__cell--actions">
          <button
            type="button"
            class="developers-table__remove-btn"
            aria-label="Remover desenvolvedor"
            (click)="deleteDeveloper(developer)">
            <b3-icon name="delete" size="sm"></b3-icon>
          </button>
        </div>
      </div>
    </div>

    <footer class="developers-table__footer">
      <p class="developers-table__summary">
        Mostrando {{ developersAdded.length }}
        {{ developersAdded.length === 1 ? 'desenvolvedor' : 'desenvolvedores' }}
      </p>

      <nav
        *ngIf="totalPages > 1"
        class="developers-table__pagination"
        aria-label="Paginação de desenvolvedores vinculados">
        <button
          type="button"
          class="developers-table__page-btn"
          aria-label="Página anterior"
          [disabled]="currentPage <= 1"
          (click)="goToPage(currentPage - 1)">
          <b3-icon name="chevron_left" size="sm"></b3-icon>
        </button>
        <span class="developers-table__page-current" aria-current="page">{{ currentPage }}</span>
        <button
          type="button"
          class="developers-table__page-btn"
          aria-label="Próxima página"
          [disabled]="currentPage >= totalPages"
          (click)="goToPage(currentPage + 1)">
          <b3-icon name="chevron_right" size="sm"></b3-icon>
        </button>
      </nav>
    </footer>
  </div>

  <p class="developers-table__empty" *ngIf="developersAdded.length === 0">
    Nenhum outro desenvolvedor cadastrado
  </p>

</div>
